const SublocationKeys = {
  TITLE: "title",
  INTLCODE: "intlcode",
  ACTIVE: "active",
  LANGUAGE: "language",
  INDICATOR: "indicator",
  ADDRESS: "address",
  SUBHEADING_ID: "subheadingId",
  DESCRIPTION_EN: "descriptionEn",
  CODE: "code",
  Validations: {
    MAX_LENGTH_250: "validations.maxLength250",
    MAX_LENGTH_10: "validations.maxLength10",
    MAX_LENGTH_150: "validations.maxLength150",
    ALPHA_NUMERIC_SPACE_REGX: "validations.alphaNumericSpaceRegx"
  },
}

export default SublocationKeys
